import React, { useEffect, useState } from 'react'
import './App.css'
import { Link, Redirect, useLocation, useHistory } from 'react-router-dom'
import ReactTooltip from 'react-tooltip'
import Axios from 'axios'
import Footer from './components/Footer'
import { IoIosArrowBack, IoIosCheckmarkCircleOutline, IoIosRadioButtonOff } from 'react-icons/io'
import { BsFillQuestionCircleFill } from 'react-icons/bs'
import { RiEditLine } from 'react-icons/ri'
import ClipLoader from 'react-spinners/ClipLoader'
import Header3 from './components/Header3'
import { v4 as uuidv4 } from 'uuid'
import { BiMenu } from 'react-icons/bi'
import Header from './layouts/Header'
import SideNav from './layouts/SideNav'
import TopBarProgress from 'react-topbar-progress-indicator'
import { API_URL } from './config'
import { event } from 'jquery'

const uuid = uuidv4().toUpperCase()
const uuid1 = uuidv4().toUpperCase()
const uuid2 = uuidv4().toUpperCase()
const uuid3 = uuidv4().toUpperCase()
const uuid4 = uuidv4().toUpperCase()
const uuid5 = uuidv4().toUpperCase()
const uuid6 = uuidv4().toUpperCase()

const baseURL = `${API_URL}/apps/kscanner/webservices.php`

const Campaign = () => {
  const location = useLocation()
  const history = useHistory()
  const [autoLaunch, setAutoLaunch] = useState(true)
  const [launchBtn, setLaunchBtn] = useState('save-btn')
  const [count, setCount] = useState(0)
  const [campaignExists, setCampaignExists] = useState('no')
  const [payfastData, setPayfastData] = useState([])
  const [businessEmail, setBusinessEmail] = useState('')
  const [telephone, setTelephone] = useState(0)
  const [campaignname, setCampaignname] = useState('')
  const [campaigId, setCampaigId] = useState(0)
  const [keywords, setKeywords] = useState('')
  const today = new Date().toISOString().split('T')[0]
  const [startdate, setStartdate] = useState(today)
  const [enddate, setEnddate] = useState('')
  const [error, setError] = useState('')
  const [estBudget, setEstBudget] = useState(10.0)
  const [creditAmount, setCreditAmount] = useState(0)
  const [currentBudget, setCurrentBudget] = useState(0)
  const [currentBalance, setCurrentBalance] = useState(0)
  const [budgetString, setBudgetString] = useState('Set budget')
  const [successError, setSuccessError] = useState('')
  const [errorDisplay, setErrorDisplay] = useState('none')
  const [description, setDescription] = useState('Loading...')
  const [spinning, setSpinning] = useState(false)
  const [campaignLoader, setCampaignLoader] = useState(false)
  const [saveCampaignBtn, setsaveCampaignBtn] = useState('save-btn')
  const [updateDisplay, setUpdateDisplay] = useState('block')
  const [btnLabel, setBtnLabel] = useState('Pay & Launch Campaign')
  const [btnLabelSaving, setBtnLabelSaving] = useState('Save campaign')
  const [nb, setNb] = useState('')

  const isMobile = window.innerWidth <= 768
  const [isMob, setIsMob] = useState()
  const [collapsed, setCollapsed] = useState(isMobile)

  const handleAutoLaunch = () => {
    setAutoLaunch(!autoLaunch)

    const data = new FormData()
    data.append('query', 'AUTO-LAUNCH-CAMPAIGN')
    data.append('event_id', location.state?.eventid)
    data.append('campaign_id', campaigId)
    data.append('auto_launch', autoLaunch ? 'no' : 'yes')
    Axios({
      method: 'POST',
      url: baseURL,
      data: data,
      withCredentials: true,
    })
      .then((response) => {
        console.log(response.data.message)
      })
      .catch((error) => {
        console.log(error)
      })
  }

  const updateIsMobile = () => {
    const mobile = window.innerWidth <= 768
    setIsMob(mobile)
    setCollapsed((prev) => (mobile ? true : prev))
  }

  const [optionOne, setOptionOne] = useState('item-select-active')
  const [optionTwo, setOptionTwo] = useState('item-select')
  const [optionThree, setOptionThree] = useState('item-select')

  const [checkedOne, setCheckedOne] = useState(true)
  const [uncheckedOne, setUncheckedOne] = useState(false)
  const [checkedTwo, setCheckedTwo] = useState(false)
  const [uncheckedTwo, setUncheckedTwo] = useState(true)
  const [checkedThree, setCheckedThree] = useState(false)
  const [uncheckedThree, setUncheckedThree] = useState(true)

  const [textColorOne, setTextColorOne] = useState('color-blue')
  const [textColorTwo, setTextColorTwo] = useState('color-black')
  const [textColorThree, setTextColorThree] = useState('color-black')

  const [quotationTextOne, setQuotationTextOne] = useState('color-blue')
  const [quotationTextTwo, setQuotationTextTwo] = useState('color-grey')
  const [quotationTextThree, setQuotationTextThree] = useState('color-grey')

  const [note, setNote] = useState(
    <label className="mt-3 mb-0 color-grey">
      A digital ticket is a virtual product which your customers will be able to buy online,
      transactions are only processed online; no physical money; all transactions are electronic.
    </label>
  )

  const [cal_budget, setCalBudget] = useState(0)
  const [ifSet, setIfSet] = useState(false)

  const eventid = location.state?.eventid
  const eventname = location.state?.eventname
  const businessname = localStorage.getItem('businessname')
  const businessid = localStorage.getItem('businessid')

  useEffect(() => {
    document.title = `${eventname} - Campaign`
    localStorage.setItem('ticket_type', 'digital')

    // Fetch Business Details
    Axios.get(`${baseURL}?query=BUSINESSDETAILS&accountid=${businessid}`, {
      withCredentials: true,
    })
      .then((response) => {
        setTelephone(response.data.phone)
        setBusinessEmail(response.data.email)
      })
      .catch((error) => {
        console.log(error)
      })

    // get estimated budget
    Axios.get(`${baseURL}?query=ESTIMATED-BUDGET&event_id=${eventid}&business_id=${businessid}`, {
      withCredentials: true,
    })
      .then((response) => {
        setEstBudget(response.data.estedBudget.replace(/,/g, ''))
        setCreditAmount(response.data.creditAmount.replace(/,/g, ''))
      })
      .catch((error) => {
        console.log(error)
      })

    // Fetch Campaign Estimate
    Axios.get(`${baseURL}?query=CAMPAIGNESTIMATE&eventid=${eventid}&business_id=${businessid}`, {
      withCredentials: true,
    }).then((response) => {
      setCampaignExists(response.data.is_campaign_exist)
      if (response.data.val === 1) {
        // setEstBudget(response.data.estBudget);
        setCurrentBudget(`${response.data.currentBudget}`)
        setCurrentBalance(`Balance: R${response.data.currentBalance}`)
        setBudgetString('Increase budget')
        setNb('')
        setCampaignname(response.data.campaign_name)
        setCampaigId(response.data.campaign_id)
        setKeywords(response.data.keywords)
        setStartdate(response.data.campaign_start_date)
        setEnddate(response.data.duration)
        setBtnLabel(
          response.data.currentBudget > 0
            ? 'Top up budget'
            : creditAmount === 0
            ? 'Pay & Launch Campaign'
            : 'Use Credit & Launch Campaign'
        )
      } else {
        // setEstBudget(response.data.estBudget);
        setCurrentBudget(`${response.data.currentBudget}`)
        setCurrentBalance(`Balance: R${response.data.currentBalance}`)
        setBudgetString('Estimated budget')
        setNb(
          <label className="mb-0 mt-2 color-grey">
            This budget is based on the <label className="mb-0 color-orange">ticket prices</label>{' '}
            and the number of tickets you fed the system.{' '}
            <Link to="/budget" className="color-blue">
              Learn more...
            </Link>
            <br />
            <br />
            <label className="mb-0 color-orange">
              <strong>NB:</strong> Ticket price only applies to digital tickets.
            </label>
          </label>
        )
        setCampaignname('')
        setKeywords('')
        setStartdate('')
        setEnddate('')
        setBtnLabel(response.data.currentBudget > 0 ? 'Top up budget' : 'Pay & Launch Campaign')
      }
    })

    updateIsMobile()
    window.addEventListener('resize', updateIsMobile)

    return () => {
      // this runs on unmount
      window.removeEventListener('resize', updateIsMobile)
    }
  }, []) // Empty dependency array — runs once on mount

  const handleCampaigname = (event) => {
    setCampaignname(event.target.value)
    setErrorDisplay('none')
  }

  const handleKeywords = (event) => {
    setKeywords(event.target.value)
    setErrorDisplay('none')
  }

  const handleDate = (event) => {
    setStartdate(event.target.value)
    setErrorDisplay('none')
  }

  const handleEnddate = (event) => {
    setEnddate(event.target.value)
    setErrorDisplay('none')
  }

  const handleBudget = (event) => {
    setEstBudget(event.target.value)
    setErrorDisplay('none')
  }

  const addPayment = (type) => {
    const businessid = localStorage.getItem('businessid')
    const budget = estBudget
    const campaign = campaignname
    const keyword = keywords
    const start_date = startdate
    const end_date = enddate
    const campaign_id = campaigId

    if (campaign === '' || campaign === null) {
      setErrorDisplay('block')
      setError('Enter the campaign name.')
      setSuccessError('error-login')
      setTimeout(() => {
        setErrorDisplay('none')
      }, 4000)
    } else if (keyword === '' || keyword === null) {
      setErrorDisplay('block')
      setError('Enter keywords related to the event, and use commas to separate.')
      setSuccessError('error-login')
      setTimeout(() => {
        setErrorDisplay('none')
      }, 4000)
    } else if (start_date === '' || start_date === null) {
      setErrorDisplay('block')
      setError("Choose a start date for the campaign—we suggest using today's date.")
      setSuccessError('error-login')
      setTimeout(() => {
        setErrorDisplay('none')
      }, 4000)
    } else if (end_date === '' || end_date === null) {
      setErrorDisplay('block')
      setError(
        'Select the campaign end date—ideally, match it to your event date or the day after.'
      )
      setSuccessError('error-login')
      setTimeout(() => {
        setErrorDisplay('none')
      }, 4000)
    } else if ((parseInt(budget) < 10 || budget === '' || budget === null) && type === 'launch') {
      setErrorDisplay('block')
      setError('Budget should at least be R10.00 minimum.')
      setSuccessError('error-login')
      setTimeout(() => {
        setErrorDisplay('none')
      }, 4000)
    } else {
      if (type === 'save') {
        setCampaignLoader(true)
        setsaveCampaignBtn('btn-disabled')
        setCount(count + 1)
        // setBtnLabelSaving(
        //   <span>
        //     <ClipLoader size={18} color="#fff" /> Saving...
        //   </span>
        // );
        setErrorDisplay('none')

        const dataForm = new FormData()
        dataForm.append('eventid', eventid)
        dataForm.append('businessid', businessid)
        dataForm.append('campaign', campaign)
        dataForm.append('keywords', keyword)
        dataForm.append('startdate', start_date)
        dataForm.append('enddate', end_date)
        dataForm.append('query', 'ADDCAMPAIGN')

        Axios({
          method: 'POST',
          url: baseURL,
          data: dataForm,
          withCredentials: true,
        })
          .then((response) => {
            if (response.data.status === 'success') {
              setCampaignLoader(false)
              setsaveCampaignBtn('save-btn')
              setBtnLabelSaving('Save campaign')
              setErrorDisplay('block')
              setSuccessError('success-login')
              setError(response.data.message)
              setCampaignExists('yes')
              setCampaignname(response.data.campaign_name)
              setCampaigId(campaigId)
              setKeywords(response.data.keywords)
              setStartdate(response.data.campaign_start_date)
              setEnddate(response.data.duration)
            } else {
              setCampaignLoader(false)
              setsaveCampaignBtn('save-btn')
              setBtnLabelSaving('Save campaign')
              setErrorDisplay('block')
              setSuccessError('error-login')
              setError(response.data.message)
            }
          })
          .catch((error) => {
            setBtnLabelSaving('Save campaign')
            setErrorDisplay('block')
            setSuccessError('error-login')
            setError(error.response.data.message)
            console.log(error)
          })

        setTimeout(() => {
          setErrorDisplay('none')
        }, 5000)
      } else {
        setLaunchBtn('btn-disabled')
        setSpinning(true)
        setErrorDisplay('none')

        let mobileSet
        const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)

        if (isMobile) {
          mobileSet = 'yes'
        } else {
          mobileSet = 'no'
        }

        const totalAmount = budget
        const formData = new FormData()
        const name_first = localStorage.getItem('businessname')
        const name_last = localStorage.getItem('businessname')

        // --------------------------------------------------------------
        // apply campaign R5000 credit for first time campaign
        if (creditAmount > 0 || API_URL === 'https://stage.karamale.com') {
          formData.append('query', 'APPLY-CREDIT-FIRST-CAMPAIGN')
          formData.append('eventid', eventid)
          formData.append('budgetAmount', totalAmount)
          formData.append('campaignId', campaign_id)

          Axios({
            method: 'POST',
            url: baseURL,
            data: formData,
            withCredentials: true,
          })
            .then((response) => {
              if (response.data.status === 'success') {
                setCampaignLoader(false)
                setsaveCampaignBtn('save-btn')
                setBtnLabelSaving('Save campaign')
                setErrorDisplay('block')
                setSuccessError('success-login')
                setError(response.data.message)
                setCampaignExists('yes')
                // setCampaignname(response.data.campaign_name)
                setCampaigId(campaigId)
                // setKeywords(response.data.keywords)
                // setStartdate(response.data.campaign_start_date)
                // setEnddate(response.data.duration)
                setSpinning(false)
              } else {
                setSpinning(false)
                setCampaignLoader(false)
                setsaveCampaignBtn('save-btn')
                setBtnLabelSaving('Pay & Launch Campaign')
                setErrorDisplay('block')
                setSuccessError('error-login')
                setError(response.data.message)
              }

              setTimeout(() => {
                setErrorDisplay('none')
              }, 4000)
            })
            .catch((error) => {
              setSpinning(false)
              setBtnLabelSaving('Pay & Launch Campaign')
              setErrorDisplay('block')
              setSuccessError('error-login')
              setError(error.response.data.message)
              console.log(error)
            })

          return
        } else {
          // --------------------------------------------------------------

          formData.append('campaign_id', campaign_id)
          formData.append('item_name', campaignname + ' campaign')
          formData.append('amount', totalAmount)
          formData.append('email', businessEmail)
          formData.append('cell_number', telephone)
          formData.append('name_first', name_first)
          formData.append('name_last', name_last)
          formData.append('eventid', eventid)
          formData.append('payment_method', 'cc')
          formData.append('businessid', businessid)
          formData.append('type', 'campaign')
          formData.append('is_mobile', 'yes')
          formData.append('category', 'campaign')

          let payData

          fetch(`${API_URL}/apps/kscanner/payfast_credentials.php`, {
            method: 'POST',
            body: formData,
          })
            .then((res) => res.json())
            .then((data) => {
              // console.log(data);

              payData = data
              // console.log(payData);

              setPayfastData(data)

              const form = document.createElement('form')
              form.method = 'POST'
              form.action = 'https://www.payfast.co.za/eng/process'

              for (const [key, value] of Object.entries(payData)) {
                const input = document.createElement('input')
                input.type = 'hidden'
                input.name = key
                input.value = value
                // console.log(`${key} = ${value}`);
                form.appendChild(input)
              }
              // console.log(form)

              document.body.appendChild(form)
              form.submit()
            })
        }
      }
    }
  }

  if (localStorage.getItem('businessname') === null) {
    return <Redirect to="/login" />
  }

  const handleToggle = () => {
    setCollapsed((prev) => !prev)
  }

  function parseCurrency(str) {
    // Remove commas and any spaces
    let cleaned = str.replace(/,/g, '').trim()
    // Convert to number
    let num = parseFloat(cleaned)
    // Return NaN if conversion fails
    return isNaN(num) ? null : num
  }

  return (
    <div className="view">
      {/* <Header3 /> */}
      <Header />
      <SideNav collapsed={collapsed} onToggle={handleToggle} />
      <div
        className="container"
        style={{
          marginTop: 40,
          marginLeft: isMob ? '0px' : collapsed ? 'auto' : 'auto',
        }}
      >
        {/* ✅ Mobile overlay when sidebar is open */}
        {isMobile && !collapsed && <div className="mobile-overlay active" onClick={handleToggle} />}

        {isMob && collapsed && (
          <label className="mobile-toggle" onClick={handleToggle}>
            <BiMenu size={25} />
          </label>
        )}
        <div className="row justify-content-center just-container-insid pb-5">
          <div
            class=" text-center mt-5 col-12 category-name-heading"
            style={{
              fontSize: 15,
              color: 'rgb(77, 77, 79)',
              textTransform: 'none',
              marginBottom: -5,
            }}
          >
            Not sure how much to spend?{' '}
            <Link to="/budget" target="_blank" style={{ color: '#3399cc' }}>
              Use our calculator to determine your budget
            </Link>
          </div>
          <div className="col-lg-7">
            <div className=" BoxDashboardContainer mt-3 mb-4 mrgin-search pl-0 pr-0">
              <div className="row align-self-center justify-content-center">
                <div className="item-list p-0">
                  <div className="col-lg-4 col-4 pl-0">
                    <button type="button" onClick={() => history.goBack()} className="link-btn">
                      <IoIosArrowBack size={25} />
                      Back &nbsp;
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className=" BoxDashboardContainer  pl-0 pr-0">
              <div className="row align-self-center justify-content-center">
                <div className="item-list p-0">
                  <div className="col-lg-12 pl-0">
                    <label className="ticket-title pl-0 pr-0 mb-0">
                      CREATE/EDIT A CAMPAIGN
                      <br />
                      <label className="small-details normal-casing">{eventname}</label>
                    </label>
                  </div>
                </div>

                <div className="h-divider w-100"></div>
              </div>
              <div className="col-lg-12 details-body">
                <span>Details</span>
                <br />
                <br />
                Campaign name
                <br />
                <input
                  type="text"
                  placeholder="Enter campaign name"
                  value={campaignname}
                  onChange={handleCampaigname}
                  className="edit-input form-control"
                  required
                />
                <br /> <br />
                Enter keyworks
                <br />
                <input
                  type="text"
                  placeholder="Enter keywords: Separate by comma"
                  value={keywords}
                  onChange={handleKeywords}
                  className="edit-input form-control"
                  required
                />
                <br /> <br />
                Set starting date
                <br />
                <input
                  type="date"
                  placeholder="Set starting date"
                  value={startdate}
                  onChange={handleDate}
                  min={today}
                  className="edit-input form-control w-100"
                  required
                />
                <br />
                <br />
                Set ending date
                <br />
                <input
                  type="date"
                  placeholder="Set ending date"
                  value={enddate}
                  onChange={handleEnddate}
                  min={startdate}
                  className="edit-input form-control w-100"
                  required
                />
                <div className="col-12 text-right p-0 mt-3">
                  <label className="back-arrow mb-0">
                    <button
                      className={`${saveCampaignBtn} w-auto`}
                      onClick={() => addPayment('save')}
                      disabled={campaignLoader ? true : false}
                    >
                      <span>
                        {campaignLoader ? (
                          <ClipLoader
                            color={'grey'}
                            loading={true}
                            // css={override}
                            size={20}
                          />
                        ) : (
                          btnLabelSaving
                        )}
                      </span>
                    </button>
                  </label>
                </div>
                {campaignExists === 'yes' ? (
                  <>
                    <hr />
                    <span className={creditAmount == 0 ? '' : 'color-green'}>
                      {creditAmount == 0 ? (
                        currentBudget > 0 ? (
                          'Top up your campaign budget'
                        ) : (
                          'Set budget and launch your campaign'
                        )
                      ) : (
                        <span>
                          🎉 Congrats! You've Unlocked R{creditAmount} in Campaign Credit.
                        </span>
                      )}
                    </span>
                    <br />
                    <label className="small-details text-12">
                      {creditAmount == 0 ? (
                        currentBudget > 0 ? (
                          'Add more funds anytime to keep your campaign strong. Top-ups start from R10.00.'
                        ) : (
                          "We've calculated your campaign budget from ticket details. You can set your own starting amount (minimum R10.00) and adjust anytime."
                        )
                      ) : (
                        <label>
                          You're launching your first campaign on Karamale — and we've backed you
                          with R{creditAmount} in credit. Use it toward your ticket budget and
                          launch with confidence.
                        </label>
                      )}
                    </label>
                    <br />
                    <input
                      type="number"
                      placeholder={'Enter amount'}
                      value={currentBudget > 0 ? 10.0 : estBudget}
                      onChange={handleBudget}
                      className="edit-input form-control mb-3"
                      required
                      min={10}
                      step={0.01}
                      readOnly={creditAmount == 0 ? false : true}
                    />
                    <div className={currentBudget > 0 ? 'd-none' : ''}>
                      <input
                        type="checkbox"
                        checked={autoLaunch}
                        className="w-auto float-left cursor-pointer"
                        id="auto-launch"
                        onChange={handleAutoLaunch}
                      />{' '}
                      <label
                        className={'ml-2 cursor-pointer'}
                        htmlFor="auto-launch"
                        style={{ marginTop: '0.7rem' }}
                      >
                        Auto-launch campaign immediately after payment.{' '}
                        {currentBudget > 0 ? '' : <span>(recommended)</span>}
                      </label>
                    </div>
                    {/* <label className={creditAmount > 0 ? 'd-none' : 'small-details text-12'}>
                      Estimated budget based on your ticket details. You can adjust anytime (min
                      R10.00)
                    </label> */}
                    {/* {nb} */}

                    {API_URL.toLowerCase() === 'https://stage.karamale.com' ? (
                      <label className="w-100 bg-warning p-2 rounded mb-2 d-inline-block mt-0">
                        You are currently in the staging environment. No real payments will be
                        processed.
                      </label>
                    ) : (
                      ''
                    )}
                    <div className="col-12 text-right p-0 mt-3">
                      <label className="back-arrow mb-0">
                        <button
                          className={`${launchBtn} w-auto`}
                          onClick={() => addPayment('launch')}
                          disabled={spinning ? true : false}
                        >
                          <span
                            style={{
                              display: updateDisplay,
                            }}
                          >
                            {spinning ? (
                              <ClipLoader
                                color={'grey'}
                                loading={true}
                                // css={override}
                                size={20}
                              />
                            ) : API_URL.toLowerCase() === 'https://stage.karamale.com' ? (
                              'Launch campaign (staging)'
                            ) : (
                              btnLabel
                            )}
                          </span>
                        </button>
                      </label>
                    </div>
                  </>
                ) : (
                  <></>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={successError} style={{ display: errorDisplay, textAlign: 'center' }}>
        {error}
      </div>
      {/* <Footer /> */}
      {/* </form> */}
    </div>
  )
}

export default Campaign
